import { render, staticRenderFns } from "./WorkOrderLinkTemplate.vue?vue&type=template&id=4c5563b7&"
import script from "./WorkOrderLinkTemplate.vue?vue&type=script&lang=js&"
export * from "./WorkOrderLinkTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports